import { render, staticRenderFns } from "./Awg.vue?vue&type=template&id=d19d8408&"
import script from "./Awg.vue?vue&type=script&lang=js&"
export * from "./Awg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports